import React from 'react';

import { CateringHeroMenuLink } from '../../catering/catering-hero/CateringHeroMenuLink';
import { CateringLandingVideoPlayer } from './catering-landing-video-player';

export const CateringLandingNavigationSection = () => {
  return (
    <div className="catering-landing-navigation ps-container-lg-margin ps-container-fixed relative">
      <div className="ps-row">
        <div className="col-xs-12">
          <div className="navigation-container">
            <div className="navigation">
              <div className="title heavier">
                Delicious inspiration for
                <br />
                every event
              </div>
              <div className="subtext">
                No matter what type of event you're having, we have the perfect culinary match. Start exploring catering options below — all crafted for you by the finest local chefs.
              </div>
              <div className="catering-landing-hero-links-wrap">
                <CateringHeroMenuLink href="#perfect-for-production" title="Perfect for production" />
                <CateringHeroMenuLink href="#photo-worthy-events" title="Photo-worthy events" />
                <CateringHeroMenuLink href="#ideal-for-meetings" title="Ideal for meetings" />
              </div>
            </div>
            <CateringLandingVideoPlayer />
          </div>
        </div>
      </div>
    </div>
  );
};
